import React from "react";
import InfoSectionText from "./InfoSectionText";
import InfoSectionParent from "./InfoSectionParent";
import ShareButtons from "../singlecomponents/ShareButtons";
import Button from "../singlecomponents/Button";
import Tag from "../tags/Tag";
import "../../stylesheet/components/media/MediaInfo.scss";
import { Media } from "../../compilers/media";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
//import i18n from "../../api/i18n";

type ArticleInfoProps = {
  media: Media;
  className?: string;
};

const ArticleInfo: React.FC<ArticleInfoProps> = ({ media, className }) => {
  const { blurb, publishDate } = media.data;
  const history = useHistory();
  const { t } = useTranslation();
  const getTags = () => {
    if (media.data.tags) {
      return media.data.tags.map((tag) => <Tag key={tag} title={tag} />);
    }
    return;
  };
  
  const goToPreviousPath = () => {
    history.goBack();
  };

  const getAuthor = () => {
    if (media.data.author && media.data.author.length > 0) {
      return (
        <InfoSectionText
          label={t("inner-page.author")}
          body={media.data.author}
        />
      );
    }
  };

  return (
    <div className={`media-inner-info ${className ? className : ""}`}>
      <p className="p2 article-blurb">{blurb}</p>
      <div className="info-divider"/>
      <div className="info-text-container">
        <InfoSectionText
          label={t("inner-page.published")}
          body={moment(publishDate).format("DD/MM/YYYY")}
        />
        {getAuthor()}
      </div>
      <div className="tags-inner">
        <InfoSectionParent label={t("inner-page.tags")}>
          {getTags()}
        </InfoSectionParent>
      </div>
      <div className="media-inner-share">
        <InfoSectionParent label={t("inner-page.share")}></InfoSectionParent>
        {<ShareButtons />}
      </div>
      <div className="back-btn" onClick={goToPreviousPath}>
        <Button bootstrapClass="px-sm-2 px-md-4 py-1" name={t("button.back")} />
      </div>
    </div>
  );
};

export default ArticleInfo;
